import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class DepartmentCategoryService {
  static loadDepartmentCategories(params) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENT_CATEGORIES}?${params}`;
    return axios.get(url).then((response) => response.data);
  }

  static getDepartmentCategory(id) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENT_CATEGORIES}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createDepartmentCategory(departmentCategory) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENT_CATEGORIES}`;
    const body = {
      departmentCategory
    };
    return axios.post(url, body).then((response) => response.data);
  }

  static updateDepartmentCategory(departmentCategory) {
    const url = `${endpoints.BASE_URL}${endpoints.DEPARTMENT_CATEGORIES}/${departmentCategory.id}`;
    const body = {
      departmentCategory
    };

    return axios.put(url, body).then((response) => response.data);
  }
}

export default DepartmentCategoryService;
